import { encodeURL } from '~/utils/helper/cyoHelper.js'

/**
 * Get cart data for checkout address page
 */
export async function getAddressData({ identifier, coupon, disableOffer, tax_exempt_id, pay_type, shared_from_pos }) {

  const payload = { identifier }

  const queryParams = {
    coupon
  }
  if (shared_from_pos) {
    queryParams.shared_from_pos = shared_from_pos
  }
  
  if (pay_type) {
    queryParams.pay_type = pay_type
  }

  // if (coupon) payload.coupon = coupon

  if (disableOffer) payload.disableOffer = true
  if (tax_exempt_id && !['', null, 'null', false, 'false', undefined, 'undefined'].includes(tax_exempt_id)) {
    payload.tax_exempt_id = tax_exempt_id
  }

  const response = await $fetch(useCountryPath('/checkout/payment?' + encodeURL(queryParams)), {
    method: 'POST',
    body: payload
  })

  if (!response.success) {
    throw new Error('Failed to fetch cart data')
  }

  return response
}


/**
 * Get user location based on IP
 */
export async function getUserLocation() {
  const response = await $fetch(useCountryPath('/get-user-location'))
  return response.data
}

/**
 * Submit address form data
 */
export async function submitAddress(addressData) {
  const response = await $fetch(useCountryPath('/checkout/address/store', true), {
    method: 'POST',
    body: addressData
  })

  if (!response.success) {
    throw new Error('Failed to store address')
  }

  return response
}


export async function validateCheckoutCart(currentIdentifier, shared_from_pos) {
  
    const response = await $fetch(useCountryPath('/checkout/validate-cart'), {
        method: 'POST',
        body: {
            identifier: currentIdentifier,
            shared_from_pos: shared_from_pos
        }
    })
    if (!response.success) {
      throw new Error('Failed to validate cart')
    }

    return response
}